import React from "react";
import {
  Box,
  Heading,
  Text,
  Flex,
  Stack,
  HStack,
  Circle,
} from "@chakra-ui/react";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import LoadingSpinner from "../LoadingSpinner";

export default function GraficoGenero({ dados, loadingGraficoGenero }) {
  const distribuicao = dados?.distribuicao || {};
  const nomes = dados?.nomes || {};
  const total = dados?.total || 0;

  const generos = Object.keys(distribuicao)
    .sort()
    .map((key) => ({
      label: nomes[key],
      value: distribuicao[key],
    }));

  const cores = [
    "#40D1BA",
    "#80ADD7",
    "#D6EDD2",
    "#FFD966",
    "#E49BC6",
    "#F28C8C",
    "#A084FF",
  ];

  const labels = generos.map((g) => g.label);
  const valores = generos.map((g) => g.value);

  const data = {
    labels,
    datasets: [
      {
        data: valores,
        backgroundColor: cores,
        hoverBackgroundColor: cores,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "50%",
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "semibold",
          size: 11,
        },

        formatter: (value) => {
          const percent = (value / total) * 100;
          return percent > 1.5 ? `${Math.round(percent)}%` : "";
        },
      },
    },
  };

  return (
    <Box
      p={6}
      shadow="lg"
      backgroundColor="#F7F8FB"
      rounded="lg"
      border="1px solid #E0E6ED"
    >
      {loadingGraficoGenero ? (
        <Flex h={"100%"} alignItems={"center"} justifyContent={"center"}>
          <LoadingSpinner />
        </Flex>
      ) : (
        <>
          <Heading fontSize="lg" mb={5} color="#2D2F44">
            Acolhidos por Gênero
          </Heading>

          <Flex
            direction={{ base: "column", sm: "row" }}
            alignItems="center"
            gap={12}
          >
            <Box width="40%">
              <Doughnut
                data={data}
                options={options}
                plugins={[ChartDataLabels]}
                height={"100px"}
              />
            </Box>

            <Stack spacing={3}>
              {generos.map((genero, index) => (
                <HStack key={genero.label}>
                  <Circle size="12px" bg={cores[index]} />
                  <Text>{genero.label}</Text>
                  <Text color="gray.600" fontWeight="bold">
                    {genero.value} ({Math.round((genero.value / total) * 100)}%)
                  </Text>
                </HStack>
              ))}
            </Stack>
          </Flex>
        </>
      )}
    </Box>
  );
}
